import type { TeamMemberQuerySchema } from '../schemas';

export const fieldNames: Record<keyof TeamMemberQuerySchema, { name: string; revertible: boolean }> = {
  first_name: { name: 'First Name', revertible: true },
  last_name: { name: 'Last Name', revertible: true },
  status: { name: 'Status', revertible: true },
  job_title: { name: 'Job Title', revertible: true },
  gender: { name: 'Gender', revertible: true },
  tech_preference: { name: 'Tech Preference', revertible: true },
  t_shirt_size: { name: 'T-Shirt Size', revertible: true },
  personal_email: { name: 'Personal Email Address', revertible: true },
  work_email: { name: 'Work Email Address', revertible: true },
  internal_extension: { name: 'Internal Extension', revertible: true },

  hired_on: { name: 'Hire', revertible: true },
  pet_names: { name: 'Pet Name', revertible: true },
  birthdate: { name: 'Birthdate', revertible: true },
  termination: { name: 'Termination', revertible: true },
  interests: { name: 'Interests', revertible: true },
  children_names: { name: 'Children', revertible: true },
  spouse_name: { name: 'Spouse Name', revertible: true },
  parent: { name: 'Manager', revertible: true },
  phone_numbers: { name: 'Phone Numbers', revertible: true },
  addresses: { name: 'Addresses', revertible: true },
  biography: { name: 'Biography', revertible: true },

  profile_image: { name: 'Profile Image', revertible: true },
  emergency_contact: { name: 'Emergency Contact', revertible: true },

  employment_agreement: { name: 'Employment Agreement', revertible: true },
  handbook_acknowledgement: { name: 'Handbook Acknowledgement', revertible: true },
  offer_letter: { name: 'Offer Letter', revertible: true },

  vector_signatured: { name: 'Victor Signature', revertible: true },
  business_card_template: { name: 'Business Card Template', revertible: true },

  gallery: { name: 'Gallery', revertible: false },

  preferred_relationship: { name: 'ID', revertible: false },
  w2_withholdings: { name: 'ID', revertible: false },
  tax_type: { name: 'ID', revertible: false },
  manual: { name: 'ID', revertible: false },
  children: { name: 'ID', revertible: false },
  hr_identifier: { name: 'ID', revertible: false },
  preferred_relationship_id: { name: 'ID', revertible: false },
  parent_id: { name: 'ID', revertible: false },
  id: { name: 'ID', revertible: false },

  harvest: { name: 'Harvest', revertible: true },
  freshdesk: { name: 'Freshdesk', revertible: true },
  gusto: { name: 'Gusto', revertible: true },
  zoom: { name: 'Zoom', revertible: true },
  lockdown_override_pin: { name: 'Financial Override PIN', revertible: false },

  commission_periods: { name: 'Commission Periods', revertible: false },
  has_lockdown_override_pin: { name: 'Financial Override PIN', revertible: false },
};
